import * as types from './types'
import { getWindow, scrollToTop, removeTrailingSlash } from 'src/utils'

let requestDemoForm = null
let techniqueParentNode = null
let categoryParentNode = null
let sendPageViewCalls = 0

export const sendPageView = (location, prevLocation) => () => {
  if (
    !getWindow() ||
    !location ||
    !prevLocation ||
    ++sendPageViewCalls < 1 ||
    prevLocation.pathname.includes(removeTrailingSlash(location.pathname))
  )
    return
  window.ga &&
    window.ga('send', {
      hitType: 'pageview',
      page: location.pathname,
    })
}

export const showForm = () => () => {
  if (!getWindow()) return
  const container = document.querySelector('.mkto-form-container')
  if (container) container.style.display = 'flex'
}

export const hideForm = () => () => {
  if (!getWindow()) return
  const container = document.querySelector('.mkto-form-container')
  if (container) container.style.display = 'none'
}

export const subscribeToResize = () => dispatch => {
  getWindow() && window.addEventListener('resize', () => dispatch(onResize()))
}

export const loadForm = () => dispatch => {
  if (!getWindow()) return
  if (process.env.GATSBY_SHOULD_LOAD_MKTO_SCRIPT === 'true') {
    window.MktoForms2.loadForm('//app-ab19.marketo.com', '280-XQP-994', 1372, marketoForm => {
      const contentNode = document.querySelector('.mkto-form-container .mkto-content')
      const form = marketoForm.getFormElem()[0]
      contentNode.appendChild(form)
      techniqueParentNode = contentNode
      categoryParentNode = contentNode
      requestDemoForm = form
    })
    return
  }
  const form = document.querySelector('#mktoForm_1372')
  if (!form) return setTimeout(() => dispatch(loadForm()), 100)
  requestDemoForm = form
  techniqueParentNode = form.parentNode
  categoryParentNode = document.querySelector('.mkto-form-container .mkto-content')
}

export const useRequestDemoScrollBehavior = () => dispatch => {
  if (!getWindow()) return
  if (!requestDemoForm) return setTimeout(() => dispatch(useRequestDemoScrollBehavior()), 100)
  categoryParentNode.appendChild(requestDemoForm)
  const contactButton = document.querySelector('.go-contact')
  contactButton && contactButton.removeEventListener('click', scrollToTop)
  window.impactUseRequestDemoScrollBehavior && window.impactUseRequestDemoScrollBehavior()
}

export const useRequestDemoLightboxBehavior = () => dispatch => {
  if (!getWindow()) return
  if (!requestDemoForm) return setTimeout(() => dispatch(useRequestDemoLightboxBehavior()), 100)
  techniqueParentNode.appendChild(requestDemoForm)
  const contactButton = document.querySelector('.go-contact')
  contactButton && contactButton.addEventListener('click', scrollToTop)
  window.impactUseRequestDemoLightboxBehavior && window.impactUseRequestDemoLightboxBehavior()
}

export const onResize = () => dispatch => {
  if (!getWindow()) return
  dispatch(setWindowWidth(document.body.clientWidth))
}

export const setShouldShowMobileCategory = value => dispatch => {
  dispatch({
    type: types.SET_SHOULD_SHOW_MOBILE_CATEGORY,
    payload: value,
  })
}

export const setWindowWidth = value => dispatch => {
  dispatch({
    type: types.SET_WINDOW_WIDTH,
    payload: value,
  })
}

export const setShouldScroll = value => dispatch => {
  dispatch({
    type: types.SET_SHOULD_SCROLL,
    payload: value,
  })
}
